import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Container, Row, Col, Modal, ModalHeader, ModalBody,
  ModalFooter, Card, CardBody, Button, Form, FormGroup,
  Label, Input, FormFeedback, Badge, Alert
} from 'reactstrap';
import MaterialTable from '@material-table/core';
import axios from 'axios';
import { Add, Edit, Delete, Refresh, CloudDownload } from '@material-ui/icons';
import swal from 'sweetalert';
import moment from 'moment';

import backend_url from "../../../routes/API_URL";
import Loader from "../../../components/Loader";

const API_URL = backend_url['api_url'];

class Schools extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // User info
      sector_id: sessionStorage.getItem('sector') || '',
      role: window.sessionStorage.getItem("urole"),
      bearer_auth: window.sessionStorage.getItem('token'),
      logged_user_id: window.sessionStorage.getItem('uid'),

      // Modal states
      modalVisible: false,
      EditModalVisible: false,
      exportDropdownOpen: false,

      // Optimized pagination states
      page: 0,
      pageSize: 50,
      totalCount: 0,
      searchText: '',
      loading: false,
      isFetching: false,
      error: null,
      rawResponse: null,
      exportLoading: false,

      // Data states
      Schools: [],
      Zones: [],
      Districts: [],
      Divisions: [],

      // Form states
      id: '',
      emis_id: '',
      school_name: '',
      establishment_type: '',
      zone_id: '',
      sector_type: '',
      school_type: '',
      proprietor: '',
      category: '',
      cluster_id: '',

      // Validation states
      EmisIdState: '',
      SchoolNameState: '',
      EstablishmentTypeState: '',
      ZoneIdState: '',
      sector_type_state: '',
      school_type_state: '',
      proprietor_state: '',
      category_state: '',

      // Other states
      jurisdiction: '',
      schoolTypes: ['Co-Education', 'Girls Only', 'Boys Only'],
      proprietors: ['Public', 'Private', 'Religious Institution'],
      categories: ['National', 'District Boarding', 'District Day', 'Community Day'],
      establishmentTypesPrimary: ['Full Primary', 'LEA'],
      establishmentTypesSecondary: ['Form 1', 'Form 1-2', 'Form 1-3', 'Form 1-4']
    };

    this.toggle = this.toggle.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.addSchools = this.addSchools.bind(this);
    this.editSchools = this.editSchools.bind(this);
    this.updateSchools = this.updateSchools.bind(this);
    this.deleteSchools = this.deleteSchools.bind(this);
    this.getSectorByZone = this.getSectorByZone.bind(this);
    this.setId = this.setId.bind(this);
    this.viewSchoolDetails = this.viewSchoolDetails.bind(this);
    this.exportAllData = this.exportAllData.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.toggleExportDropdown = this.toggleExportDropdown.bind(this);
  }

  componentDidMount() {
    this.fetchInitialData();
    this.fetchData();
  }

  // Fetch initial data
  fetchInitialData = () => {
    const bearer_auth = this.state.bearer_auth;

    // Fetch zones
    axios.get(API_URL + '/zones', {
      headers: { "Authorization": `Bearer ${bearer_auth}` }
    })
      .then(response => {
        this.setState({ Zones: response.data || [] });
      })
      .catch(error => {
        console.error('Error fetching zones:', error);
      });
  }

  // Optimized fetchData method
  fetchData = (page = 0, pageSize = this.state.pageSize, search = '') => {
    return new Promise((resolve, reject) => {
      this.setState({ isFetching: true, error: null });

      const role = this.state.role;
      const bearer_auth = this.state.bearer_auth;
      let url = API_URL + '/schools';

      const params = {
        page: page + 1,
        per_page: Math.min(500, pageSize),
        search: search || ''
      };

      // Add sector filter if selected
      if (this.state.sector_id) {
        params.sector_id = this.state.sector_id;
      }

      // Construct URL based on user role
      if (role === 'Division Manager') {
        const div_id = window.sessionStorage.getItem('division');
        url = API_URL + `/divisions/school/${div_id}`;
      } else if (role === 'DEM') {
        const dist_id = window.sessionStorage.getItem('district');
        url = API_URL + `/districts/school/${dist_id}`;
      } else if (role === 'PEA' || role === 'Secondary Advisor') {
        const zon_id = window.sessionStorage.getItem('zone');
        url = API_URL + `/zones/school/${zon_id}`;
      }

      // console.log('Fetching schools data from:', url, 'with params:', params);

      axios.get(url, {
        headers: {
          "Authorization": `Bearer ${bearer_auth}`,
          "Accept": "application/json"
        },
        params: params
      })
        .then(response => {
          const responseData = response.data;
          console.log('Raw API response:', responseData);

          // Handle different response structures
          let schoolsData = [];
          let totalCount = 0;

          if (Array.isArray(responseData)) {
            schoolsData = responseData;
            totalCount = responseData.length;
          } else if (responseData && responseData.data) {
            schoolsData = responseData.data || [];
            totalCount = responseData.total || schoolsData.length || 0;
          } else {
            schoolsData = [];
            totalCount = 0;
          }

          this.setState({
            Schools: schoolsData,
            totalCount: totalCount,
            page: page,
            pageSize: pageSize,
            loading: false,
            isFetching: false,
            rawResponse: responseData,
            jurisdiction: this.getJurisdictionText()
          }, () => {
            resolve({
              data: schoolsData,
              page: page,
              totalCount: totalCount
            });
          });
        })
        .catch(error => {
          console.error('Error fetching schools:', error);
          this.handleApiError(error);
          reject(error);
        });
    });
  }

  // Optimized API error handling
  handleApiError = (error) => {
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to load schools data";

    this.setState({
      loading: false,
      isFetching: false,
      error: errorMessage
    });

    if (error.response?.status === 401) {
      swal({
        title: "",
        text: "Your session has expired. You'll automatically be logged out within seconds.",
        icon: "warning",
        timer: 2000
      }).then(() => {
        window.sessionStorage.clear();
        window.location.reload();
      });
    } else {
      swal({
        title: "Error",
        text: errorMessage,
        icon: "error",
        button: true
      });
    }
  }

  // Get jurisdiction text
  getJurisdictionText = () => {
    const role = this.state.role;

    switch (role) {
      case 'Division Manager':
        const division = window.sessionStorage.getItem('division_name');
        return `SCHOOLS IN ${division || ''} DIVISION`;
      case 'DEM':
        const district = window.sessionStorage.getItem('district_name');
        return `SCHOOLS IN ${district || ''} DISTRICT`;
      case 'PEA':
      case 'Secondary Advisor':
        const zone = window.sessionStorage.getItem('zone_name');
        return `SCHOOLS IN ${zone || ''} ${this.state.sector_id == 1 ? 'ZONE' : 'CLUSTER'}`;
      default:
        return "SCHOOLS IN MALAWI";
    }
  }

  // View school details
  viewSchoolDetails = (school) => {
    const details = `
EMIS ID: ${school.emis_id}
School Name: ${school.school_name}
Zone/Cluster: ${school.zone_name}
Sector: ${school.sector_id == 1 ? 'Primary' : 'Secondary'}
Establishment Type: ${school.establishment_type}
Proprietor: ${school.proprietor}
School Type: ${school.school_type}
Category: ${school.school_category || school.institution_type || 'N/A'}

Location Details:
- Zone ID: ${school.zone_id}
- District ID: ${school.district_id || 'N/A'}
- Division ID: ${school.division_id || 'N/A'}

Last Updated: ${school.updated_at ? moment(school.updated_at).format('YYYY-MM-DD HH:mm:ss') : 'N/A'}
Created: ${school.created_at ? moment(school.created_at).format('YYYY-MM-DD HH:mm:ss') : 'N/A'}
    `;

    swal({
      title: "School Details",
      text: details,
      icon: "info",
      content: document.createElement('pre'),
      buttons: {
        close: {
          text: "Close",
          value: "close"
        }
      }
    });
  }

  // Get school type badge color
  getSchoolTypeColor = (schoolType) => {
    switch (schoolType) {
      case 'Co-Education': return 'primary';
      case 'Girls Only': return 'danger';
      case 'Boys Only': return 'info';
      default: return 'secondary';
    }
  }

  // Get proprietor badge color
  getProprietorColor = (proprietor) => {
    switch (proprietor) {
      case 'Public': return 'success';
      case 'Private': return 'warning';
      case 'Religious Institution': return 'info';
      default: return 'secondary';
    }
  }

  // Get sector badge
  getSectorBadge = (sectorId) => {
    return sectorId == 1 ?
      { color: 'primary', text: 'Primary' } :
      { color: 'secondary', text: 'Secondary' };
  }

  // Toggle modals
  toggle() {
    this.setState(prevState => ({
      modalVisible: !prevState.modalVisible,
      emis_id: '',
      school_name: '',
      establishment_type: '',
      zone_id: '',
      sector_type: '',
      school_type: '',
      proprietor: '',
      category: '',
      EmisIdState: '',
      SchoolNameState: '',
      EstablishmentTypeState: '',
      ZoneIdState: ''
    }));
  }

  toggleEdit() {
    this.setState(prevState => ({
      EditModalVisible: !prevState.EditModalVisible,
      id: '',
      emis_id: '',
      school_name: '',
      establishment_type: '',
      zone_id: '',
      sector_type: '',
      school_type: '',
      proprietor: '',
      category: ''
    }));
  }

  // Get zones by sector
  getSectorByZone(e) {
    const sectorId = e.target.value;
    if (!['1', '2'].includes(sectorId)) return;

    this.setState({ loading: true });

    axios.get(API_URL + `/zones/by_sector/${sectorId}`, {
      headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
    })
      .then(response => {
        this.setState({
          Zones: response.data,
          sector_id: sectorId,
          cluster_id: sectorId,
          loading: false
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        this.handleApiError(error);
      });
  }

  // Edit school
  editSchools(id) {
    this.setState({ loading: true });

    axios.get(API_URL + `/schools/edit/${id}`, {
      headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
    })
      .then(response => {
        const school = response.data[0];
        this.setState({
          id: school.emis_id,
          emis_id: school.emis_id,
          school_name: school.school_name,
          establishment_type: school.establishment_type,
          sector_id: school.sector_id,
          zone_id: school.zone_id,
          school_type: school.school_type,
          proprietor: school.proprietor,
          category: school.school_category || school.institution_type || '',
          EditModalVisible: true,
          loading: false
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        this.handleApiError(error);
      });
  }

  // Update school
  updateSchools(event) {
    event.preventDefault();
    this.setState({ loading: true });

    const school = {
      school_name: this.state.school_name,
      establishment_type: this.state.establishment_type,
      zone_id: this.state.zone_id,
      sector_id: this.state.sector_id,
      proprietor: this.state.proprietor,
      school_type: this.state.school_type,
      emis_id: this.state.emis_id,
      category: this.state.category
    };

    axios.patch(API_URL + `/schools/update/${this.state.id}`, school, {
      headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
    })
      .then(response => {
        if (response.data.status === 'success') {
          swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
            timer: 1250
          }).then(() => {
            this.setState({ EditModalVisible: false, loading: false });
            this.fetchData();
          });
        } else {
          swal({
            title: "Error",
            text: response.data.message,
            icon: "error",
            button: true
          });
          this.setState({ loading: false });
        }
      })
      .catch(error => {
        this.setState({ loading: false });
        this.handleApiError(error);
      });
  }

  // Delete school
  deleteSchools(id) {
    swal({
      title: "Confirm Delete",
      text: "Are you sure you want to delete this school?",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"]
    }).then(willDelete => {
      if (willDelete) {
        this.setState({ loading: true });

        axios.delete(API_URL + `/schools/delete/${id}`, {
          headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
        })
          .then(response => {
            swal({
              title: "Deleted",
              text: "School deleted successfully!",
              icon: "success",
              timer: 2000
            }).then(() => {
              this.setState({ loading: false });
              this.fetchData();
            });
          })
          .catch(error => {
            this.setState({ loading: false });
            this.handleApiError(error);
          });
      }
    });
  }

  // Add school
  addSchools(event) {
    event.preventDefault();
    this.setState({ loading: true });

    const school = {
      emis_id: this.state.emis_id,
      school_name: this.state.school_name,
      establishment_type: this.state.establishment_type,
      zone_id: this.state.zone_id,
      sector_id: this.state.sector_id,
      proprietor: this.state.proprietor,
      school_type: this.state.school_type,
      category: this.state.category
    };

    axios.post(API_URL + '/schools', school, {
      headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
    })
      .then(response => {
        if (response.data.status === 'success') {
          swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
            timer: 1250
          }).then(() => {
            this.setState({ modalVisible: false, loading: false });
            this.fetchData();
          });
        } else {
          swal({
            title: "Error",
            text: response.data.message,
            icon: "error",
            button: true
          });
          this.setState({ loading: false });
        }
      })
      .catch(error => {
        this.setState({ loading: false });
        this.handleApiError(error);
      });
  }

  // Form input handler
  handleInput(e) {
    const { name, value, id } = e.target;

    // Update the field value
    this.setState({ [id]: value });

    // Update validation state
    const stateName = name.charAt(0).toUpperCase() + name.slice(1) + 'State';
    if (this.state.hasOwnProperty(stateName)) {
      this.setState({ [stateName]: value ? 'has-success' : 'has-danger' });
    }
  }

  // Set ID
  setId(e) {
    this.setState({ [e.target.id]: e.target.value });
  }

  // Export all data
  exportAllData = () => {
    this.setState({ exportLoading: true });

    swal({
      title: "Export Schools Data",
      text: "This will export all schools data as a CSV file.",
      icon: "info",
      buttons: ["Cancel", "Export"],
    }).then(willExport => {
      if (willExport) {
        // Generate CSV content
        const headers = ['EMIS ID', 'School Name', 'Zone/Cluster', 'Sector', 'Establishment Type', 'Proprietor', 'School Type', 'Category'];
        const csvData = [
          headers.join(','),
          ...this.state.Schools.map(school => [
            school.emis_id,
            `"${school.school_name}"`,
            `"${school.zone_name}"`,
            school.sector_id == 1 ? 'Primary' : 'Secondary',
            `"${school.establishment_type}"`,
            `"${school.proprietor}"`,
            `"${school.school_type}"`,
            `"${school.school_category || school.institution_type || ''}"`
          ].join(','))
        ].join('\n');

        // Create and download file
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `schools-export-${moment().format('YYYY-MM-DD')}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        this.setState({ exportLoading: false });
        this.toggleExportDropdown();
      } else {
        this.setState({ exportLoading: false });
      }
    });
  }

  // Refresh data
  refreshData = () => {
    this.fetchData(this.state.page, this.state.pageSize, this.state.searchText);
  }

  // Toggle export dropdown
  toggleExportDropdown = () => {
    this.setState(prevState => ({
      exportDropdownOpen: !prevState.exportDropdownOpen
    }));
  }

  render() {
    const {
      Schools, Zones, loading, isFetching, modalVisible, EditModalVisible,
      role, sector_id, error, totalCount, jurisdiction
    } = this.state;

    const columns = [
      {
        title: 'EMIS ID',
        field: 'emis_id',
        width: 100,
        render: rowData => (
          <div>
            <div><strong>{rowData.emis_id}</strong></div>
            
          </div>
        )
      },
      {
        title: 'School Name',
        field: 'school_name',
        render: rowData => (
          <div>
            <div><strong>{rowData.school_name}</strong></div>
            {/* <small className="text-muted">{rowData.zone_name}</small> */}
          </div>
        )
      },
      {
        title: sector_id == 1 ? 'Zone' : 'Cluster',
        field: 'zone_name',
        render: rowData => (
          <div>
            <div><strong>{rowData.zone_name}</strong></div>

          </div>
        )
      },
      {
        title: 'Sector',
        field: 'sector_id',
        width: 100,
        render: rowData => {
          const sector = this.getSectorBadge(rowData.sector_id);
          return (
            <Badge color={sector.color} className="px-2 py-1">
              {sector.text}
            </Badge>
          );
        }
      },
      // {
      //   title: 'Establishment',
      //   field: 'establishment_type',
      //   width: 120,
      //   render: rowData => (
      //     <div>
      //       <div>{rowData.establishment_type}</div>
      //       <small className="text-muted">
      //         {rowData.proprietor === 'Public' && rowData.school_category ?
      //           rowData.school_category : rowData.institution_type || 'N/A'}
      //       </small>
      //     </div>
      //   )
      // },
      // {
      //   title: 'Type',
      //   field: 'school_type',
      //   width: 100,
      //   render: rowData => (
      //     <Badge color={this.getSchoolTypeColor(rowData.school_type)} className="px-2 py-1">
      //       {rowData.school_type}
      //     </Badge>
      //   )
      // },
      {
        title: 'Proprietor',
        field: 'proprietor',
        width: 120,
        render: rowData => (
          <Badge color={this.getProprietorColor(rowData.proprietor)} className="px-2 py-1">
            {rowData.proprietor}
          </Badge>
        )
      },
      {
        title: 'Actions',
        field: 'actions',
        export: false,
        sorting: false,
        width: 180,
        render: rowData => (
          <div className="d-flex">
            {/* View Details Button */}
            <Button
              color="link"
              size="sm"
              onClick={() => this.viewSchoolDetails(rowData)}
              title="View Details"
              className="mr-1"
            >
              <i className="mdi mdi-eye-outline text-info"></i>
            </Button>

            {/* Edit button for System Administrator */}
            <Button
              color="link"
              size="sm"
              onClick={() => this.editSchools(rowData.emis_id)}
              disabled={role !== 'System Administrator'}
              title="Edit School"
              className="mr-1"
            >
              <Edit className="text-primary" />
            </Button>

            {/* Delete button for System Administrator */}
            <Button
              color="link"
              size="sm"
              onClick={() => this.deleteSchools(rowData.emis_id)}
              disabled={role !== 'System Administrator'}
              title="Delete School"
              className="mr-1"
            >
              <Delete className="text-danger" />
            </Button>
          </div>
        )
      }
    ];

    // Calculate statistics
    const primarySchools = Schools.filter(s => s.sector_id == 1).length;
    const secondarySchools = Schools.filter(s => s.sector_id == 2).length;
    const publicSchools = Schools.filter(s => s.proprietor === 'Public').length;
    const privateSchools = Schools.filter(s => s.proprietor === 'Private').length;

    return (
      <Container fluid>
        {/* {loading && <Loader />} */}

        {/* Page Header */}
        <Row className="align-items-center mb-4">
          <Col sm={6}>
            <div className="page-title-box">
              <h4 className="page-title mb-0">
                <i className="mdi mdi-school-outline mr-2"></i>
                Schools Management
              </h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Schools</li>
              </ol>
            </div>
          </Col>
          <Col sm={6} className="text-right">
            <Button
              color="success"
              onClick={this.toggle}
              disabled={role !== 'System Administrator'}
              className="mr-2"
            >
              <Add /> New School
            </Button>
            <Button
              color="info"
              onClick={this.refreshData}
              disabled={isFetching}
              className="mr-2"
              title="Refresh Data"
            >
              <Refresh />
            </Button>
            <div className="badge badge-light p-2">
              <i className="mdi mdi-counter mr-1"></i>
              {totalCount.toLocaleString()} Total Schools
            </div>
          </Col>
        </Row>

        {error && (
          <Row className="mb-3">
            <Col>
              <Alert color="danger">
                <h5 className="alert-heading">Error Loading Data</h5>
                <p>{error}</p>
              </Alert>
            </Col>
          </Row>
        )}

        {/* Main Content */}
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="card-title mb-0">{jurisdiction}</h5>
                  <div className="d-flex">
                    <Badge color="primary" className="mr-2 px-2">Primary</Badge>
                    <Badge color="secondary" className="mr-2 px-2">Secondary</Badge>
                    <Badge color="success" className="px-2">Public</Badge>
                    <Badge color="warning" className="px-2 ml-2">Private</Badge>
                  </div>
                </div>

                <p className="text-muted mb-4">
                  Manage school information, track school types, and view detailed school profiles.
                </p>

                {/* Material Table with Optimized Pagination */}
                <MaterialTable
                title="Schools List"
                  columns={columns}
                  data={query => {
                    return new Promise((resolve, reject) => {
                      const page = query.page;
                      const pageSize = query.pageSize;
                      const search = query.search || '';

                      this.fetchData(page, pageSize, search)
                        .then(() => {
                          resolve({
                            data: this.state.Schools,
                            page: this.state.page,
                            totalCount: this.state.totalCount
                          });
                        })
                        .catch(error => {
                          reject(error);
                        });
                    });
                  }}
                  isLoading={isFetching}
                  options={{
                    exportButton: {
                      csv: true,
                      pdf: false
                    },
                    exportFileName: `schools-${moment().format('YYYY-MM-DD')}`,
                    tableLayout: 'auto',
                    loadingType: 'overlay',
                    pageSize: this.state.pageSize,
                    pageSizeOptions: [10, 25, 50, 100, 200],
                    emptyRowsWhenPaging: false,
                    columnsButton: true,
                    exportAllData: false,
                    actionsColumnIndex: -1,
                    search: true,
                    
                    sorting: true,
                    debounceInterval: 500,
                    showFirstLastPageButtons: true,
                    paginationType: 'normal',
                    padding: 'dense',
                    rowStyle: {
                      fontSize: '0.9rem'
                    },
                    headerStyle: {
                      backgroundColor: '#f8f9fa',
                      fontWeight: '600',
                      fontSize: '0.9rem'
                    },
                    paging: true,
                    serverSide: true,
                    pagingPosition: 'bottom'
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: 'No schools found. Add a new school to get started.',
                      addTooltip: 'Add',
                      deleteTooltip: 'Delete',
                      editTooltip: 'Edit',
                      filterRow: {
                        filterTooltip: 'Filter'
                      }
                    },
                    pagination: {
                      labelRowsSelect: 'rows per page',
                      labelDisplayedRows: '{from}-{to} of {count}',
                      firstTooltip: 'First Page',
                      previousTooltip: 'Previous Page',
                      nextTooltip: 'Next Page',
                      lastTooltip: 'Last Page'
                    },
                    toolbar: {
                      searchTooltip: 'Search schools',
                      searchPlaceholder: 'Search by EMIS, name, zone, or proprietor...',
                      exportTitle: 'Export',
                      exportName: 'Export as CSV',
                      exportCSVName: 'Export as CSV'
                    },
                    header: {
                      actions: 'Actions'
                    }
                  }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

       

        {/* Add School Modal */}
        <Modal isOpen={modalVisible} toggle={this.toggle} size="lg">
          <Form onSubmit={this.addSchools}>
            <ModalHeader toggle={this.toggle}>
              <center>ADD NEW SCHOOL</center>
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label for="emis_id">EMIS ID <span className="text-danger">*</span></Label>
                <Input
                  type="number"
                  name="emis_id"
                  id="emis_id"
                  value={this.state.emis_id}
                  onChange={this.handleInput}
                  invalid={this.state.EmisIdState === 'has-danger'}
                  required
                />
                <FormFeedback invalid>This field is required</FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="school_name">School Name <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  name="school_name"
                  id="school_name"
                  value={this.state.school_name}
                  onChange={this.handleInput}
                  invalid={this.state.SchoolNameState === 'has-danger'}
                  required
                />
                <FormFeedback invalid>This field is required</FormFeedback>
              </FormGroup>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="sector_type">Sector Type <span className="text-danger">*</span></Label>
                    <Input
                      type="select"
                      name="sector_type"
                      id="sector_type"
                      value={this.state.sector_type}
                      onChange={(e) => { this.handleInput(e); this.getSectorByZone(e); }}
                      invalid={this.state.sector_type_state === 'has-danger'}
                      required
                    >
                      <option value="">Select Sector</option>
                      <option value="1">Primary</option>
                      <option value="2">Secondary</option>
                    </Input>
                    <FormFeedback invalid>This field is required</FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="zone_id">
                      {this.state.cluster_id == 1 ? 'Zone' : 'Cluster'} <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      name="zone_id"
                      id="zone_id"
                      value={this.state.zone_id}
                      onChange={this.handleInput}
                      invalid={this.state.ZoneIdState === 'has-danger'}
                      required
                      disabled={!this.state.Zones.length}
                    >
                      <option value="">Select {this.state.cluster_id == 1 ? 'Zone' : 'Cluster'}</option>
                      {this.state.Zones.map(zone => (
                        <option key={zone.zone_id} value={zone.zone_id}>
                          {zone.zone_name}
                        </option>
                      ))}
                    </Input>
                    <FormFeedback invalid>This field is required</FormFeedback>
                  </FormGroup>
                </Col>
              </Row>

              {this.state.sector_id && (
                <FormGroup>
                  <Label for="establishment_type">
                    Establishment Type <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="select"
                    name="establishment_type"
                    id="establishment_type"
                    value={this.state.establishment_type}
                    onChange={this.handleInput}
                    invalid={this.state.EstablishmentTypeState === 'has-danger'}
                    required
                  >
                    <option value="">Select Establishment Type</option>
                    {this.state.sector_id == 1 ? (
                      this.state.establishmentTypesPrimary.map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))
                    ) : (
                      this.state.establishmentTypesSecondary.map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))
                    )}
                  </Input>
                  <FormFeedback invalid>This field is required</FormFeedback>
                </FormGroup>
              )}

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="proprietor">Proprietor <span className="text-danger">*</span></Label>
                    <Input
                      type="select"
                      name="proprietor"
                      id="proprietor"
                      value={this.state.proprietor}
                      onChange={this.handleInput}
                      invalid={this.state.proprietor_state === 'has-danger'}
                      required
                    >
                      <option value="">Select Proprietor</option>
                      {this.state.proprietors.map(prop => (
                        <option key={prop} value={prop}>{prop}</option>
                      ))}
                    </Input>
                    <FormFeedback invalid>This field is required</FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="school_type">School Type <span className="text-danger">*</span></Label>
                    <Input
                      type="select"
                      name="school_type"
                      id="school_type"
                      value={this.state.school_type}
                      onChange={this.handleInput}
                      invalid={this.state.school_type_state === 'has-danger'}
                      required
                    >
                      <option value="">Select School Type</option>
                      {this.state.schoolTypes.map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </Input>
                    <FormFeedback invalid>This field is required</FormFeedback>
                  </FormGroup>
                </Col>
              </Row>

              {this.state.proprietor === 'Public' && this.state.sector_id == 2 && (
                <FormGroup>
                  <Label for="category">School Category <span className="text-danger">*</span></Label>
                  <Input
                    type="select"
                    name="category"
                    id="category"
                    value={this.state.category}
                    onChange={this.handleInput}
                    invalid={this.state.category_state === 'has-danger'}
                    required
                  >
                    <option value="">Select Category</option>
                    {this.state.categories.map(cat => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                  </Input>
                  <FormFeedback invalid>This field is required</FormFeedback>
                </FormGroup>
              )}
            </ModalBody>
            <ModalFooter>
              <Button type="submit" color="success" disabled={loading}>
                {loading ? 'Processing...' : 'Create School'}
              </Button>
              <Button color="danger" onClick={this.toggle}>Cancel</Button>
            </ModalFooter>
          </Form>
        </Modal>

        {/* Edit School Modal */}
        <Modal isOpen={EditModalVisible} toggle={this.toggleEdit} size="lg">
          <Form onSubmit={this.updateSchools}>
            <ModalHeader toggle={this.toggleEdit}>
              <center>EDIT SCHOOL</center>
            </ModalHeader>
            <ModalBody>
              <Input type="hidden" name="id" id="id" value={this.state.id} readOnly />

              <FormGroup>
                <Label for="emis_id">EMIS ID <span className="text-danger">*</span></Label>
                <Input
                  type="number"
                  name="emis_id"
                  id="emis_id"
                  value={this.state.emis_id}
                  onChange={this.handleInput}
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label for="school_name">School Name <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  name="school_name"
                  id="school_name"
                  value={this.state.school_name}
                  onChange={this.handleInput}
                  required
                />
              </FormGroup>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="zone_id">
                      {this.state.sector_id == 1 ? 'Zone' : 'Cluster'} <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      name="zone_id"
                      id="zone_id"
                      value={this.state.zone_id}
                      onChange={this.handleInput}
                      required
                    >
                      <option value="">Select {this.state.sector_id == 1 ? 'Zone' : 'Cluster'}</option>
                      {Zones.map(zone => (
                        <option key={zone.zone_id} value={zone.zone_id}>
                          {zone.zone_name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="establishment_type">
                      Establishment Type <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      name="establishment_type"
                      id="establishment_type"
                      value={this.state.establishment_type}
                      onChange={this.handleInput}
                      required
                    >
                      <option value="">Select Establishment Type</option>
                      {this.state.sector_id == 1 ? (
                        this.state.establishmentTypesPrimary.map(type => (
                          <option key={type} value={type}>{type}</option>
                        ))
                      ) : (
                        this.state.establishmentTypesSecondary.map(type => (
                          <option key={type} value={type}>{type}</option>
                        ))
                      )}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="proprietor">Proprietor <span className="text-danger">*</span></Label>
                    <Input
                      type="select"
                      name="proprietor"
                      id="proprietor"
                      value={this.state.proprietor}
                      onChange={this.handleInput}
                      required
                    >
                      <option value="">Select Proprietor</option>
                      {this.state.proprietors.map(prop => (
                        <option key={prop} value={prop}>{prop}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="school_type">School Type <span className="text-danger">*</span></Label>
                    <Input
                      type="select"
                      name="school_type"
                      id="school_type"
                      value={this.state.school_type}
                      onChange={this.handleInput}
                      required
                    >
                      <option value="">Select School Type</option>
                      {this.state.schoolTypes.map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              {this.state.proprietor === 'Public' && this.state.sector_id == 2 && (
                <FormGroup>
                  <Label for="category">School Category</Label>
                  <Input
                    type="select"
                    name="category"
                    id="category"
                    value={this.state.category}
                    onChange={this.handleInput}
                  >
                    <option value="">Select Category</option>
                    {this.state.categories.map(cat => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                  </Input>
                </FormGroup>
              )}
            </ModalBody>
            <ModalFooter>
              <Button type="submit" color="success" disabled={loading}>
                {loading ? 'Processing...' : 'Update School'}
              </Button>
              <Button color="danger" onClick={this.toggleEdit}>Cancel</Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Container>
    );
  }
}

export default Schools;